// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"PageLayout_pageLayout__3fYJh","pageLayout__padding":"PageLayout_pageLayout__padding__1v2E4","sidenav":"PageLayout_sidenav__sMI0R"};